import { Controller } from "stimulus"

// Filtre dynamiquement la liste des langues vivantes selon la filière choisie.
//
// Attributs attendus sur l'élément portant le controller (cf. CandidateHelper#sector_languages_data) :
//   data-sector-languages-map          : { "<sector_id>": [<language_id>, ...] }
//   data-sector-languages-languages    : [{ id, name }, ...]
//   data-sector-languages-placeholder  : texte de l'option vide
//
// Une filière absente de la map (aucune langue configurée) propose toutes les langues.
export default class extends Controller {
  static targets = [ 'sector', 'language' ];

  connect() {
    if (!this.hasSectorTarget || !this.hasLanguageTarget) return;

    this.map = JSON.parse(this.data.get('map') || '{}');
    this.languages = JSON.parse(this.data.get('languages') || '[]');
    this.placeholder = this.data.get('placeholder') || '';

    // Premier rendu : on conserve la langue déjà enregistrée, même si elle n'est plus proposée.
    this._refresh({ keepCurrent: true });
  }

  // Appelé au changement de filière.
  filter() {
    this._refresh({ keepCurrent: false });
  }

  _refresh({ keepCurrent }) {
    const current = this.languageTarget.value;
    const allowedIds = this._allowedIds(this.sectorTarget.value);

    const options = this.languages.filter(language =>
      allowedIds.includes(language.id) || (keepCurrent && String(language.id) === current)
    );
    const selected = options.some(language => String(language.id) === current) ? current : '';

    this._render(options, selected);
  }

  _allowedIds(sectorId) {
    const ids = this.map[sectorId];
    if (!ids || ids.length === 0) return this.languages.map(language => language.id);
    return ids;
  }

  _render(options, selected) {
    const select = this.languageTarget;

    if (select.choices) {
      const choices = [
        { value: '', label: this.placeholder, placeholder: true, selected: selected === '' },
        ...options.map(language => ({
          value: String(language.id),
          label: language.name,
          selected: String(language.id) === selected
        }))
      ];
      select.choices.clearStore();
      select.choices.setChoices(choices);
      return;
    }

    // Repli si Choices.js n'est pas (encore) initialisé sur ce select.
    select.innerHTML = '';
    select.add(new Option(this.placeholder, ''));
    options.forEach(language => select.add(new Option(language.name, language.id)));
    select.value = selected;
  }
}
